// src/pages/cashier-system/ManualCashier

import { useState } from "react";
import { useLocation } from "react-router-dom";
// import useRequest from "../../../utils/useRequest";
import PageWrapper from "../../components/PageWrapper";
import ManualCashierBody from "./View-item-invoice/ManualCashierBody";
import ManualCashierFooter from "./View-item-invoice/ManualCashierFooter";

export default function ManualCashier() {
  const location = useLocation();
  const dataFromNavigation = location.state?.data;
  const [data, setData] = useState(dataFromNavigation);

  return (
    <PageWrapper>
      {/* <ItemInvoiceHeader invoiceHeader={data?.documentPath} /> */}
      <ManualCashierBody data={data} setData={setData} mode="preview" />
      {/* <ManualCashierFooter /> */}
    </PageWrapper>
  );
}
